import { Header } from '@tanstack/react-table'

/**
 * Checks if all subheaders of a header are placeholders.
 */
export const areSubHeadersPlaceholders = (
    currentHeader: Header<unknown, unknown>
): boolean => {
    return (
        currentHeader.subHeaders.length > 0 &&
        currentHeader.subHeaders.every((subHeader) => subHeader.isPlaceholder)
    )
}

/**
 * Recursively checks if all subheaders and their descendants are placeholders.
 * Except leaf cells
 */
export const areSubHeadersPlaceholdersRecursive = (
    currentHeader: Header<unknown, unknown>
): boolean => {
    const allSubHeadersPlaceholder = currentHeader.subHeaders.every(
        (subHeader) =>
            subHeader.isPlaceholder || subHeader.subHeaders.length === 0
    )

    return (
        allSubHeadersPlaceholder &&
        currentHeader.subHeaders.every(areSubHeadersPlaceholdersRecursive)
    )
}
